import styles from '../ConfigurationForm.module.css';

interface SegmentedControlProps {
  options: { value: number; label: string }[];
  value: number;
  onChange: (v: number) => void;
}

export const SegmentedControl = ({
  options,
  value,
  onChange
}: SegmentedControlProps) => {
  return (
    <div className={styles.segmentedControl}>
      {options.map((opt) => (
        <button
          key={opt.value}
          className={value === opt.value ? styles.segActive : ''}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};
